// client/src/config/apiBase.js
// Shared API base resolution for browser requests.

const DEFAULT_API_PATH = "/api";

function normalizeApiBase(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (raw.startsWith("/")) return raw.replace(/\/+$/, "") || "/";
  if (/^https?:\/\//i.test(raw)) return raw.replace(/\/+$/, "");
  if (/^(localhost|127\.0\.0\.1)(:\d+)?(\/.*)?$/i.test(raw)) {
    return `http://${raw}`.replace(/\/+$/, "");
  }
  return `https://${raw}`.replace(/\/+$/, "");
}

// In development, prefer same-origin relative paths so CRA can proxy requests
// to whichever backend target is configured locally.
export const API_BASE_URL =
  normalizeApiBase(process.env.REACT_APP_API_URL) ||
  DEFAULT_API_PATH;

export const SERVER_ROOT = API_BASE_URL.replace(/\/api\/?$/, "") || "";
